module.exports = __webpack_public_path__ + "src/img/artist/indexpic03.jpg?067898e92496eb85565f0b46618dbbb7";


//////////////////
// WEBPACK FOOTER
// ./src/img/artist/indexpic03.jpg
// module id = 130
// module chunks = 0